export default "__VITE_ASSET__fdd312e5__"